module.exports = __webpack_public_path__ + "img/pic_button_start_en@2x.42b81e49.png";